// @ts-nocheck
import { CASE_UPLOAD_FILE_ERROR, CASE_UPLOAD_FILE_LOADING, CASE_UPLOAD_FILE_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const case_upload_file = (data, base64File) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: CASE_UPLOAD_FILE_LOADING,
                data: true
            })
            Authservices.case_upload_file(data, base64File).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: CASE_UPLOAD_FILE_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: CASE_UPLOAD_FILE_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}